import { render, staticRenderFns } from "./PerseuInputFile.vue?vue&type=template&id=7ff3edca&"
import script from "./PerseuInputFile.vue?vue&type=script&lang=js&"
export * from "./PerseuInputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports